import { Badge } from '@/components/ui/badge'
import { renewalFlag } from '@/lib/sla'
import type { RenewalState } from '@/lib/sla'
import { cn } from '@/lib/utils'

const VARIANTS = { warning: 'warning', danger: 'destructive', neutral: 'neutral' } as const

/** The renewal flag, with "SLAs off" beside an upcoming or ended term whose SLAs are switched off; compact stacks them. */
export function RenewalBadge({ state, slasOff, compact = false, className }: { state: RenewalState; slasOff: boolean; compact?: boolean; className?: string }) {
  const flag = renewalFlag(state, { compact })
  if (!flag) return null
  return (
    <span className={cn('inline-flex gap-1.5', compact ? 'flex-col items-start' : 'flex-wrap items-center')}>
      <Badge variant={VARIANTS[flag.tone]} className={className}>
        {flag.label}
      </Badge>
      {slasOff && (state.kind === 'upcoming' || state.kind === 'ended') && (
        <Badge variant="neutral" className={className}>
          SLAs off
        </Badge>
      )}
    </span>
  )
}
